import { useMutation } from 'react-query';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { getReportVehiclesWithoutMovement } from './vehicleWithoutMovements.service';

export function useVehiclesWithoutMovementReport() {
  return useMutation(getReportVehiclesWithoutMovement, {
    onSuccess() {
      notification.success({
        message: 'Relatório de veículos sem movimentação gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
